module.exports = "/assets/72ff4fb51b9239eef3444a56a7aa1016.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/ST.png
// module id = 2954
// module chunks = 0